export const news = {
  newsFeedCreateInputPlaceholder: 'Skriv ett inlägg...',
  newsFeedSearchInputPlaceholder: 'Sök',
  newsFeedPostOwnerCurtainEditTitle: 'Redigera inlägg',
  newsFeedPostOwnerCurtainDeleteTitle: 'Ta bort inlägg',
  newsFeedEditedPostSavedAlertText: 'Inlägg sparat!',
  newsFeedEditedPostDeletedAlertText: 'Inlägg borttaget!',
  newsFeedShareCurtainOptionTitle: 'Kopiera länk',
  newsFeedPostLinkCopiedAlertText: 'Länk kopierad!',
  newsFeedOthersPostCurtainOptionCopyTitle: 'Kopiera länk',
  newsFeedOthersPosLinkCopiedAlertText: 'Länk kopierad!',
  newsFeedOthersPostCurtainOptionFlagTitle: 'Flagga innehåll',
  newsFeedOtherPostOwnersCurtainDeleteTitle: 'Ta bort inlägg',
  newsFeedPostDeletePopupTitle: 'Ta bort',
  newsFeedPostDeletePopupText: 'Vill du ta bort det här inlägget?',
  newsFeedPostDeletePopupCancelButtonTitle: 'Avbryt',
  newsFeedPostDeletePopupConfirmButtonTitle: 'Bekräfta',
  newsFeedPostDeeletedAlertText: 'Inlägg borttaget!',
  newsPostDetailsHeaderTitle: 'Inlägg',
  postFeedPostLikesText: 'Gilla',
  postFeedPostCommentsText: 'Kommentarer',
  postFeedPostNoLikesText: 'Det finns inga gillanden ännu',
  postFeedPostLeaveFirstLikeText: 'Du kan vara den första att gilla',
  newsFeedPostDetailsNoCommentsText: 'Det finns inga kommentarer ännu',
  newsFeedPostDetailsFirstCommentText: 'Du kan vara den första att kommentera',
  newsFeedPostDetailsShareOptionTitle: 'Kopiera länk',
  newsFeedPostDetailsSharePostCopiedAlertText: 'Länk kopierad!',
  newsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Kopiera länk',
  newsFeedPostDetailsCopiedAlertText: 'Länk kopierad!',
  newsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Flagga innehåll',
  newsPostDetailsFlagCurtainOptionSpamTitle: 'Anmäl',
  newsPostDetailsReportedCurtainText: 'Innehåll anmält',
  newsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Redigera kommentar',
  newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Ta bort kommentar',
  newsPostDetailsEditedCommentSavedAlertText: 'Kommentar sparad!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Ta bort kommentar',
  postDetailsOtherUsersCommentDeletadAlertText: 'Kommentar borttagen!',
  postDetailsDeleteCommentPopupTitle: 'Ta bort',
  postDetailsDeleteCommentPopupText: 'Vill du ta bort den här kommentaren?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Avbryt',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Bekräfta',
  postDetailsCommDeletedAlertText: 'Kommentar borttagen!',
  postDetailsCommentUserCurtainOptionTitle: 'Flagga kommentar',
  newsCreatePostCurtainTitle: 'Nytt inlägg',
  newsCreatePostCurtainBodyPlaceholder: 'Skriv ditt inlägg här...',
  newsCreatePostPublishButtonTitle: 'Publicera',
  newsCreatePostUploadSlallerImageAlertText: 'Du kan endast ladda upp upp till {size} MB åt gången',
  newsPostSavedAlertText: 'Inlägg sparad!',
  newsCreatePostAddLocationCurtainTitle: 'Plats',
  newsCreatePostAddLocationCurtainInputPlaceholder: 'Platsnamn',
  newsCreatePostEditLocationCurtainText: 'Redigera plats',
  newsDeleteLocation: 'Ta bort plats',
  newsDiscardPostPopupTitle: 'Utkast',
  newsDiscardPostPopupText: 'Vill du slänga det här utkastet?',
  newsDiscardPostPopupCancelButtonTitle: 'Avbryt',
  newsDiscardPostPopupCofirmButtonTitle: 'Bekräfta',
  newsNewPostCreatePollTitle: 'Skapa omröstning',
  newsNewPostCreatePollTitleInputPlaceholder: 'Titel',
  newsNewPostCreatePollOptionInputPlaceholder: 'Alternativ',
  newsNewPostCreatePollAddButtonTitle: 'Lägg till alternativ',
  newsNewPostCreatePollCreateButtonTitle: 'Skapa',
  newsCreatePostPollTitleBlankAlertText: 'Titeln får inte vara tom!',
  newsCreatePostPollOptionBlankAlertText: 'Alternativet får inte vara tomt!',
  newsCreatePostPollLongTitleAlertText: 'Titeln kan innehålla högst {length} tecken',
  newsCreatePostPollLongOptionAlertText: 'Alternativet kan innehålla högst {length} tecken',
  newsCreatePostPollEditOptionTitle: 'Redigera omröstning',
  newsCreatePostPollRemoveOptionTitle: 'Ta bort omröstning',
  newsPostPollInfoVotesText: 'röster',
  newsPostPollInfoEditVoteText: 'Redigera röst',
  newsPostPollFinishPollText: 'Avsluta omröstningen',
  newsPostPollFinishedPollText: 'Avslutad',
  newsPostPollInProgresslText: 'Pågående',
  newsFinishPollCurtainTitle: 'Avsluta omröstningen',
  newsFinishPollCurtainText: 'Användare kommer inte kunna rösta när omröstningen är avslutad.',
  newsFinishPollCurtainCancelButtonTitle: 'Avbryt',
  newsFinishPollCurtainConfirmlButtonTitle: 'Bekräfta',
  newsPollInfoPollVotesCurtainTitle: 'Omröstningsröster',
  newsEditPostCurtainTitle: 'Redigera inlägg',
  newsEditPostCurtainNoTextBodyPlaceholder: 'Skriv ditt inlägg här...',
  newsEditPostCurtainSaveButtonTitle: 'Spara',
  newsEditPostSavedAlertText: 'Inlägg sparad!',
  newsError: 'Något gick fel!',
  newsAt: 'kl.',
  newsSeeMore: 'Se mer...',
  newsMaxAttachments: 'Du har överskridit det maximala antalet bilagor. Maximalt antal bilagor är {length}',
  newsReply: 'Svara',
  newsPin: 'Fäst inlägg',
  newsUnpin: 'Avfäst inlägg'
}
